import CreateAccount from '@/components/CreateAccount';
import RestaurantPicker from '@/components/RestaurantPicker';
import UserAccount from '@/components/UserAccount';
import CheckoutPayment from '@/components/CheckoutPayment';
import DesktopMain from '../components/DesktopMain';
import DesktopConfirmation from '../components/DesktopConfirmation';
import DesktopMenu from '../components/DesktopMenu';
import DesktopKidsMenu from '../components/DesktopKidsMenu';
import DesktopFriesMenu from '../components/DesktopFriesMenu';
import DesktopLazyMenu from '../components/DesktopLazyMenu';
import DesktopOptions from '../components/DesktopOptions';

const routes = [
  {
    path:      '/',
    name:      'main',
    component: DesktopMain,
    meta:      {
      hideHeader: true,
    },
  },
  {
    path:      '/options',
    name:      'options',
    component: DesktopOptions,
    meta:      {
      hideHeader: true,
    },
  },
  {
    path:      '/reset-password/confirm/:uid/:token',
    name:      'reset-password',
    component: DesktopMain,
    meta:      {
      hideHeader: true,
    },
  },
  {
    path:      '/restaurants',
    name:      'restaurant-picker',
    component: RestaurantPicker,
    meta:      {
      hideHeader: true,
    },
  },
  {
    path:      '/confirmation',
    name:      'order-confirmation',
    component: DesktopConfirmation,
    props:     route => ({ checkId: route.query.check_id }),
  },
  {
    path:      '/create-account',
    name:      'create-account',
    component: CreateAccount,
    meta:      {
      hideHeader:         true,
      registrationHeader: true,
    },
  },
  {
    path:      '/account',
    name:      'account',
    component: UserAccount,
  },
  {
    path:      '/menu',
    name:      'menu',
    component: DesktopMenu,
  },
  {
    path:      '/kids-menu',
    name:      'kids-menu',
    component: DesktopKidsMenu,
  },
  {
    path:      '/fries-menu',
    name:      'fries-menu',
    component: DesktopFriesMenu,
  },
  {
    path:      '/lazy-menu',
    name:      'lazy-menu',
    component: DesktopLazyMenu,
  },
  {
    path:      '/checkout',
    name:      'checkout',
    component: CheckoutPayment,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/apps/desktop/router/index.js